import React from "react";
import { useTranslation } from "react-i18next";
import ConfirmActionDialog from "../../../components/ConfirmActionDialog";

const ConfirmResetEntitlement = ({
  open = true,
  onClose,
  onConfirm,
  loading = false,
  leaveType = "",
}) => {
  const { t } = useTranslation();

  const handleClose = () => {
    if (loading) return;
    onClose?.();
  };

  return (
    <ConfirmActionDialog
      open={open}
      variant="warning"
      title={t("common.reset-entitlements-to-default", { leaveType })}
      subtitle={t("common.confirm-reset-entitlements-message")}
      confirmText={t("button.confirm")}
      loading={loading}
      onClose={handleClose}
      onConfirm={onConfirm}
    />
  );
};

export default ConfirmResetEntitlement;
